<template> </template>

<script>
export default {
  name: "Dropdown",
  props: ["name", "list"],
};
</script>
